import { render, staticRenderFns } from "./Common-link.vue?vue&type=template&id=02a20c3a&scoped=true&"
import script from "./Common-link.vue?vue&type=script&lang=js&"
export * from "./Common-link.vue?vue&type=script&lang=js&"
import style0 from "./Common-link.vue?vue&type=style&index=0&id=02a20c3a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a20c3a",
  null
  
)

export default component.exports